import React from 'react'
import ComplianceTextCheckInline from './ComplianceTextCheckInline'
import { Button } from './ui/button'

/**
 * 홍보용(카테고리) 랜딩 저장 전: 하단 심의필 문구 입력 + 표현 리스크 점검.
 */
export default function CategoryLandingSaveReviewModal({
  open,
  onClose,
  noticeDraft,
  onNoticeDraftChange,
  getComplianceText,
  onConfirmSave,
  saving,
}) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-[85]">
      <button
        type="button"
        className="absolute inset-0 bg-black/45"
        onClick={onClose}
        aria-label="저장 검토 닫기"
      />
      <div className="relative flex min-h-full items-center justify-center px-3 py-10 sm:px-4 pointer-events-none">
        <div
          className="pointer-events-auto w-full max-w-lg rounded-2xl border border-slate-200 bg-white shadow-2xl overflow-hidden"
          role="dialog"
          aria-modal="true"
          aria-labelledby="category-landing-save-review-title"
        >
          <div className="flex items-start justify-between gap-3 border-b border-slate-100 px-4 py-4 sm:px-5">
            <div>
              <h2 id="category-landing-save-review-title" className="text-base font-bold text-slate-900">
                저장 전 확인
              </h2>
              <p className="mt-1 text-[12px] leading-snug text-slate-500">
                하단에 노출할 심의필·준법 표기를 입력하고, 필요 시 표현 리스크를 점검한 뒤 저장하세요.
              </p>
            </div>
            <button
              type="button"
              className="shrink-0 rounded-lg border border-slate-200 px-3 py-1.5 text-sm hover:bg-slate-50"
              onClick={onClose}
            >
              닫기
            </button>
          </div>

          <div className="max-h-[min(72vh,calc(100vh-6rem))] overflow-y-auto px-4 py-4 sm:px-5 space-y-4">
            <div className="rounded-xl border border-amber-200 bg-amber-50/80 p-3 space-y-2">
              <label className="block text-xs font-semibold text-amber-950" htmlFor="category-landing-ad-review-notice">
                하단 광고 심의필·준법 표기 <span className="text-red-600">*</span>
              </label>
              <p className="text-[11px] leading-relaxed text-amber-950/90">
                공개 페이지 맨 아래에 그대로 노출됩니다. 소속사에서 받은 심의필 번호·유효기간·표기 문구를 입력해 주세요.
              </p>
              <textarea
                id="category-landing-ad-review-notice"
                className="w-full min-h-[100px] rounded-lg border border-amber-200/90 bg-white px-3 py-2 text-sm text-slate-900 shadow-inner"
                value={noticeDraft}
                onChange={(e) => onNoticeDraftChange(e.target.value)}
                maxLength={4000}
                placeholder="예) ○○ 준법감시인 심의필 제○호 (20××.××.×× ~ 20××.××.××)"
              />
            </div>

            <div>
              <div className="mb-2 text-xs font-semibold text-slate-700">표현 리스크 점검</div>
              <ComplianceTextCheckInline getText={getComplianceText} label="점검 실행" />
            </div>
          </div>

          <div className="flex flex-col gap-2 border-t border-slate-100 bg-slate-50/90 px-4 py-4 sm:flex-row sm:flex-wrap sm:justify-end sm:px-5">
            <Button type="button" variant="sgezOutline" className="w-full sm:w-auto" onClick={onClose} disabled={saving}>
              수정으로 돌아가기
            </Button>
            <Button
              type="button"
              className="w-full sm:w-auto bg-brand-navy text-white hover:opacity-95"
              onClick={onConfirmSave}
              disabled={saving}
            >
              {saving ? '저장 중…' : '저장하기'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
